export default "__VITE_ASSET__DQhfyEuQ__"